<template>
  <!-- Generator: Adobe Illustrator 16.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <svg
    id="Layer_1"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="184.686px"
    height="156.667px"
    viewBox="78.332 78.333 184.686 156.667"
    enable-background="new 78.332 78.333 184.686 156.667"
    xml:space="preserve"
  >
    <g>
      <polygon
        fill="#FF6B4A"
        points="83.715,78.333 83.715,102.172 140.666,96.306 161.688,96.306 161.688,134.895 126.291,145.722 
		78.332,157.29 85.452,180.596 131.413,162.936 161.688,153.687 161.688,217.03 140.666,217.03 83.715,211.161 83.715,235 
		257.635,235 257.635,211.161 200.683,217.03 179.66,217.03 179.66,153.687 209.786,162.889 255.9,180.596 263.017,157.29 
		215.188,145.756 179.66,134.895 179.66,96.306 200.683,96.306 257.635,102.172 257.635,78.333 	"
      />
    </g>
  </svg>
</template>
